import React, { useState } from "react"
import Proptypes from "prop-types"
import {
  Card,
  CardText,
  CardBody,
  CardTitle,
  CardFooter,
  Col,
  Row,
} from "reactstrap"
import LearnMore from "../Buttons/learnMoreCardButton"

const EachProductFeature = props => {
  return (
    <div className="each-product-feature">
      <div className="title-wrapper">
        <Card className={props.linkTitle ? "left-align" : ""}>
          <div className="card-image">
            <img
              src={props.img}
              alt="Meetrix.IO is the leading Jitsi Meet commercial service provider"
            />
          </div>
          <CardBody>
            <CardTitle className="medium-font">{props.title}</CardTitle>
            <CardText className="small-font">{props.description}</CardText>
          </CardBody>
          {props.linkTitle ? (
            <LearnMore linkTitle={props.linkTitle} link={props.link} />
          ) : (
            ""
          )}
        </Card>
      </div>
    </div>
  )
}

EachProductFeature.prototype = {
  img: Proptypes.any,
  title: Proptypes.any,
  description: Proptypes.any,
  link: Proptypes.any,
  linkTitle: Proptypes.any,
}

export default EachProductFeature
